import ImmutableModel from '../immutable.model';

/**
 * The current user of the system.
 */
class User extends ImmutableModel {
  /**
   * @param {number} id
   * @param {string} first_name
   * @param {string} last_name
   * @param {string} email
   * @param {string} phone_number
   * @param {string} other_phone_number
   * @param {?Address} address
   * @param {?boolean} marketing_consent_entry
   * @param {?boolean} medical_marketing_consent_entry
   * @param (?boolena) medical_data_sharing
   * @param {?boolean} is_registered
   * @param {?boolean} is_valid
   * @param {?number} favourite_doctors
   * @param {?string} gender
   * @param {?number} birth_year
   * @param {?array.<number>} favourite_locations
   * @param {?boolean} inform_consent Can the user be informed of Oral's services
   */
  constructor(
    id,
    first_name,
    last_name,
    email,
    phone_number,
    other_phone_number,
    address,
    marketing_consent_entry,
    medical_marketing_consent_entry,
    medical_data_sharing,
    is_registered,
    is_valid,
    favourite_doctors,
    gender,
    birth_year,
    favourite_locations,
    unanswered_contact_questions,
    inform_consent=null
  ) {
    super();

    this.id = id;
    this.first_name = first_name;
    this.last_name = last_name;
    this.email = email;
    this.phone_number = phone_number;
    this.other_phone_number = other_phone_number;
    this.address = address;
    this.marketing_consent_entry = marketing_consent_entry;
    this.medical_marketing_consent_entry = medical_marketing_consent_entry;
    this.medical_data_sharing = medical_data_sharing,
    this.is_registered = is_registered;
    this.is_valid = is_valid;
    this.favourite_doctors = favourite_doctors;
    this.gender = gender;
    this.birth_year = birth_year;
    this.favourite_locations = favourite_locations;
    this.unanswered_contact_questions = unanswered_contact_questions;
    this.inform_consent = inform_consent;
  }

  copy() {
    return new User(
      this.id,
      this.first_name,
      this.last_name,
      this.email,
      this.phone_number,
      this.other_phone_number,
      this.address,
      this.marketing_consent_entry,
      this.medical_marketing_consent_entry,
      this.medical_data_sharing,
      this.is_registered,
      this.is_valid,
      this.favourite_doctors,
      this.gender,
      this.birth_year,
      this.favourite_locations,
      this.unanswered_contact_questions,
      this.inform_consent,
    );
  }

  fullName() {
    return `${this.first_name} ${this.last_name}`;
  }

  hasFavourites() {
    return this.favourite_doctors.length > 0 ||
      this.favourite_locations.length > 0;
  }
}

export default User;
